// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const StockCheckInStock: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#71984a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 10 8" width={width} height={height}>
            <path
                fill="currentColor"
                d="M9.897.858a.38.38 0 0 1 0 .52L3.825 7.645a.35.35 0 0 1-.505 0L.105 4.327a.38.38 0 0 1 0-.52.35.35 0 0 1 .505 0l2.962 3.056L9.392.858a.35.35 0 0 1 .505 0"
            />
        </svg>
    );
};

export default React.memo(StockCheckInStock);
